"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var Index_1 = __importDefault(require("../Link/Index"));

var material_1 = require("@mui/material");

var style_1 = __importDefault(require("./style"));

var IconWithText = function (props) {
  var icon = props.icon,
      children = props.children,
      anchor = props.anchor,
      linkAttributes = props.linkAttributes,
      testid = props.testid;

  var defaultProps = __assign({}, props);

  var anchorDirection;

  switch (anchor) {
    case "right":
      anchorDirection = style_1["default"].right;
      break;

    case "bottom":
      anchorDirection = style_1["default"].bottom;
      break;

    default:
      anchorDirection = style_1["default"].left;
  }

  return react_1["default"].createElement(material_1.Box, __assign({}, defaultProps, {
    css: anchorDirection,
    "data-testid": testid
  }), icon, react_1["default"].createElement(Index_1["default"], __assign({}, linkAttributes), children));
};

exports["default"] = IconWithText;